module.exports = __webpack_public_path__ + "static/media/zhanhuiBuss.005e87e9.svg";